import Skeleton from 'react-loading-skeleton';

export const repoSkeletonColumns = [
  {
    className: 'h-8 w-8',
    content: <Skeleton className="h-8 w-8" circle />,
  },
  {
    className: 'w-4/12',
    content: (
      <div className="w-[80%] ml-4">
        <Skeleton className="h-3" />
        <Skeleton className="h-2 !w-7/12" />
      </div>
    ),
  },
  {
    className: 'w-2/12 px-10',
    content: <Skeleton width="80%" className="h-2" />,
  },
  {
    className: 'w-2/12 px-10',
    content: <Skeleton className="h-2" />,
  },
  {
    className: 'w-3/12 text-right',
    content: <Skeleton width="30%" className="h-2" />,
  },
];

export const documentsTableSkeletonColumns = [
  {
    className: 'h-6 w-6',
    content: <Skeleton className="h-6 w-6" circle />,
  },
  {
    className: 'w-2/12 pr-20',
    content: (
      <div className="w-[80%] ml-4">
        <Skeleton className="h-2" />
      </div>
    ),
  },
  {
    className: 'w-2/12 pr-20',
    content: (
      <div className="w-[80%] ml-4">
        <Skeleton className="h-2" />
      </div>
    ),
  },
  {
    className: 'w-5/12',
    content: (
      <div className="flex items-center w-[40%]">
        <div className="h-6 w-6 rounded-full mr-3">
          <Skeleton className="h-6 w-6" circle />
        </div>

        <div className="w-full flex-1">
          <Skeleton className="h-2" />
        </div>
      </div>
    ),
  },
  {
    className: 'w-1/12',
    content: (
      <div className="h-6 w-6 rounded-full">
        <Skeleton className="h-6 w-6" circle />
      </div>
    ),
  },
  {
    className: 'w-2/12 text-right',
    content: <Skeleton className="h-2" width="50%" />,
  },
];
